import Icon from '../../components/Icon.vue'

Icon.register({"brands/vimeo-v":{"width":448,"height":512,"paths":[{"d":"M447.8 153.6C445.8 197.2 415.4 256.9 356.4 332.7 295.5 411.9 244 451.5 201.8 451.5 175.7 451.5 153.6 427.4 135.5 379.2 100.3 250 85.3 174.3 56.2 174.3 52.8 174.3 41.1 181.4 21 195.4L0 168.2C51.6 122.9 100.9 72.5 131.8 69.7 166.7 66.3 188.1 90.2 196.2 141.2 224.9 322.7 237.6 350.1 289.8 267.9 308.5 238.3 318.6 215.8 320 200.3 324.8 154.4 284.2 157.5 256.7 169.3 278.7 97.2 320.8 62.2 382.9 64.2 428.7 65.4 450.4 95.3 447.8 153.6z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/brands/vimeo-v.js